import React from 'react';
const features = [{
  title: 'Lavagne tattiche stampabili',
  desc: 'Diagrammi a tutto schermo per il time-out.'
}, {
  title: 'Diagrammi professionali',
  desc: 'Schemi pronti per ogni situazione di gioco.'
}, {
  title: 'Segnali visivi',
  desc: 'Comunicazione silenziosa con il playmaker.'
}, {
  title: 'Video Scouting',
  desc: "Analizza l'avversario dal telefono in pochi minuti."
}, {
  title: 'Schede individuali giocatore',
  desc: 'Storico, metriche e obiettivi personali.'
}, {
  title: 'Analisi avversari',
  desc: 'Modello in 5 dati per il vantaggio tattico.'
}, {
  title: 'Report professionali per la società',
  desc: 'Documenti pronti da consegnare.'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-34">
            Kit Tattico <span className="text-[#FF6B00]" data-id="element-35">Pro</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg sm:text-xl font-medium max-w-2xl mx-auto" data-id="element-36">
            Il sistema che fa sembrare ogni allenatore un professionista
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-37">
          {features.map((f, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl p-5 flex items-start gap-4" data-id="element-38">
              <span className="text-[#00C853] text-xl flex-shrink-0 mt-0.5" data-id="element-39">
                ✅
              </span>
              <div data-id="element-40">
                <h4 className="text-white font-bold text-base mb-1" data-id="element-41">
                  {f.title}
                </h4>
                <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-42">
                  {f.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}